const pageIds = {
	screenSaver: 'screen-saver',
	languages: 'languages',
	termsAndConditions: 'terms-and-conditions',
	fullTermsAndConditions: 'full-terms-and-conditions',
	selectInvoiceType: 'select-invoice-type',
	findYourAccount: 'find-your-account',
	lookupAccount: 'lookup-account',
	selectAccounts: 'select-accounts',
	confirmSelectedAccount: 'confirm-selected-account',
	isThereAnotherAccount: 'is-there-another-account',
	paymentAmount: 'payment-amount',
	escrowNotice: 'escrow-notice',
	payorInformation: 'payor-information',
	paymentMethod: 'payment-method',
	paymentCheckLegalNotice: 'payment-check-legal-notice',
	selectCardType: 'select-card-type',
	paymentCash: 'payment-cash',
	paymentCheck: 'payment-check',
	paymentCardMagtek: 'payment-card-magtek',
	paymentCard: 'payment-card',
	paymentComplete: 'payment-complete',
	receiptInput: 'receipt-input',
	receiptPrint: 'receipt-print',
	receiptDigital: 'receipt-digital',
	thankYou: 'thank-you',
	kioskPaymentOptions: 'kiosk-payment-options',
	endSession: 'end-session',
} as const;

export default pageIds;
